module.exports = __webpack_public_path__ + "img/Number=1.32d1e1e4.png";